import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeFarmsComponent } from './home-farms/home-farms.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { ToastaModule } from 'ngx-toasta';
import { BidiModule } from '@angular/cdk/bidi';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DeviceDetectorModule } from 'ngx-device-detector';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {MatStepperModule} from '@angular/material/stepper';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { Step1Component } from './create-farm-stepper/step1/step1.component';
import { Step2Component } from './create-farm-stepper/step2/step2.component';
import { Step3Component } from './create-farm-stepper/step3/step3.component';
import { CreateFarmComponent } from './create-farm-stepper/create-farm/create-farm.component';
import { FilterFarmsComponent } from './filter-farms/filter-farms.component';
import { MapFarmsComponent } from './map-farms/map-farms.component';
import { ParticularFarmComponent } from './particular-farm/particular-farm.component';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { ImgzoomComponent } from './imgzoom/imgzoom.component';
import { MapPruebaComponent } from './map-prueba/map-prueba.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NgxFileDropModule } from 'ngx-file-drop';



@NgModule({
  declarations: [
    HomeFarmsComponent, CreateFarmComponent,
    Step1Component, Step2Component, Step3Component, FilterFarmsComponent, MapFarmsComponent, ParticularFarmComponent, ImageUploadComponent, ImgzoomComponent, MapPruebaComponent],
  imports: [
  TranslateModule,
  MatButtonModule,
  FlexLayoutModule,
  LoadingBarRouterModule,
  LoadingBarModule,
  ToastaModule,
  BidiModule,
  SlickCarouselModule,
  DeviceDetectorModule,
  PerfectScrollbarModule,
  RouterModule,
  CommonModule, FormsModule, ReactiveFormsModule,
  MatCardModule,
  MatMenuModule,
  MatToolbarModule,
  MatIconModule,
  MatInputModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatExpansionModule,
  MatSelectModule,
  MatSnackBarModule,
  MatTooltipModule,
  MatChipsModule,
  MatListModule,
  MatSidenavModule,
  MatTabsModule,
  MatProgressBarModule,
  MatCheckboxModule,
  MatSliderModule,
  MatRadioModule,
  MatDialogModule,
  MatGridListModule,
  CdkStepperModule,
  MatStepperModule,
  NgxFileDropModule,
  ModalModule.forRoot(),
  CarouselModule.forRoot()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CreateFarmComponent, HomeFarmsComponent, ParticularFarmComponent]
})
export class FarmModule { }
